

import Script from 'next/script';

const DispatchClickScript = () => {
  return (
    <Script id="dispatch_click" strategy="beforeInteractive">
      {`
        setTimeout(function () {
          document.body?.dispatchEvent?.(new Event("click"));
        }, 300);
        setTimeout(function () {
          document.body?.dispatchEvent?.(new Event("click"));
        }, 600);
      `}
    </Script>
  );
};

export default DispatchClickScript;
